import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { setCompletedStep } from "../../utils/localstorage";

const ArLabStep8 = () => {
  let { labId, labStep } = useParams<any>();
  const history = useHistory();
  const step = parseInt(labStep);
  useEffect(() => {
    // Step is completed right away
    setCompletedStep(labId, labStep);
  }, []);
  return (
    <div className="w-full" style={{ maxWidth: 500 }}>
      <h1 className="heading-1">MPEG</h1>
      <p>
        <span className="tag">MPEG </span>
        står för Moving Pictures Expert Group, som på svenska betyder expertgruppen för rörliga bilder. Vi pratar om
        rörliga digitala bilder.
        <br />
        <br />
        Grunden för <span className="abbr">MPEG</span> och rörliga digitala bilder är en innovation från Linköping,
        något som du säkert använder varje dag, d.v.s. digtal video och TV. I en annan labb får du lära dig mer om{" "}
        <span className="abbr">MPEG</span>.
        <br />
        <br />
        <span
          className="tag text-white cursor-pointer"
          onClick={() => {
            history.push(`/${labId}/${step + 1}`);
          }}>
          fortsätt
        </span>
      </p>
      <div className="w-full h-24"></div>
    </div>
  );
};

export default ArLabStep8;
